document.addEventListener('DOMContentLoaded', () => {
  const quizRoot = document.querySelector('.play-quiz');
let activeTimerInterval = null;
let skippedQuestionIndexes = [];
  if (!quizRoot || !window.playQuizQuestions) return;

  const categoryButtons = quizRoot.querySelectorAll('[data-category]');

  categoryButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const category = button.dataset.category;
      startQuiz(category);
    });
  });

  function startQuiz(category) {
    const questions = window.playQuizQuestions[category];

    if (!questions || questions.length === 0) return;

    const randomIndex = Math.floor(Math.random() * questions.length);
    const question = questions[randomIndex];

    showQuizIntro(category, question);
  }
function showQuizIntro(category, question) {
  quizRoot.innerHTML = `
    <div class="play-quiz__intro-screen">

      

      <p class="play-quiz__intro-eyebrow">
        Bereit?
      </p>

      <h2 class="play-quiz__intro-title">
        Der Challenge-Gewinner ist dran
      </h2>

      <p class="play-quiz__intro-text">
        Der Spieler, der die vorherige Challenge gewonnen hat,
        beantwortet jetzt die Frage und hat dafür
        <strong>30 Sekunden Zeit.</strong>
      </p>

      <div class="play-quiz__intro-hint">
        <strong>Wichtig</strong>

        <p>
          Nur der aktive Spieler darf später die Lösung sehen.
          Ist die Antwort falsch, bekommt der Gegner noch eine Chance.
        </p>
      </div>

      <button
        type="button"
        class="play-quiz__intro-button"
        data-start-question
      >
        Frage starten
      </button>

    </div>
  `;

  quizRoot
    .querySelector('[data-start-question]')
    ?.addEventListener('click', () => {
      renderQuestion(category, question);
    });
}

function renderQuestion(category, question) {
  quizRoot.innerHTML = `
    <div class="play-quiz__game">

      <div class="play-quiz__game-topbar">
        <button
          type="button"
          class="play-quiz__game-back"
          data-quiz-back
        >
          ← Zurück
        </button>

        <div class="play-quiz__game-logo-wrap">
          <img
            class="play-quiz__game-logo"
            src="${window.playQuizLogo || ''}"
            alt="Look at my dog"
          >
        </div>
      </div>

      <div class="play-quiz__game-meta">

        <div class="play-quiz__category-meta">
         <div class="play-quiz__category-meta-icon ${getCategoryClass(category)}">
  ${getCategoryIcon(category)}
</div>

          <span class="play-quiz__game-category">
            ${formatCategory(category)}
          </span>
        </div>

        <div class="play-quiz__timer" data-quiz-timer>
          00:30
        </div>

      </div>

      <div class="play-quiz__question-card" data-question-card>

  <div class="play-quiz__question-card-inner">

    <div class="play-quiz__question-face play-quiz__question-face--front">
      <p class="play-quiz__question-label">Frage</p>

      <h2 class="play-quiz__question">
        ${question.question}
      </h2>
    </div>

    <div class="play-quiz__question-face play-quiz__question-face--back">
      <p class="play-quiz__question-label">Lösung</p>

      <h2 class="play-quiz__answer">
        ${question.answer}
      </h2>
    </div>

  </div>

<button
  type="button"
  class="play-quiz__new-question-button"
  data-new-question
>
  ↻ Frage schon bekannt? Andere wählen
</button>


      <button
        type="button"
        class="play-quiz__solution-button"
        data-show-solution
      >
        Lösung anzeigen
      </button>

<div class="play-quiz__answer-actions" data-answer-actions>
  <button
    type="button"
    class="play-quiz__answer-button play-quiz__answer-button--correct"
    data-answer-correct
  >
    ✓ Richtig
  </button>

  <button
    type="button"
    class="play-quiz__answer-button play-quiz__answer-button--wrong"
    data-answer-wrong
  >
    ✕ Falsch
  </button>
</div>

      <p class="play-quiz__solution-hint"
      data-solution-hint>
        Erst antippen, wenn der aktive Spieler geantwortet hat.
      </p>

      <div class="play-quiz__hint-box">
        <div class="play-quiz__hint-icon">
          💡
        </div>

        <div>
          <strong>Hinweis</strong>
          <p>
            Nur der aktive Spieler darf die Lösung lesen.
            
          </p>
        </div>
      </div>

    </div>
  `;

  startTimer(30);

  quizRoot
    .querySelector('[data-quiz-back]')
    ?.addEventListener('click', () => {
      window.location.reload();
    });

  quizRoot
    .querySelector('[data-show-solution]')
    ?.addEventListener('click', () => {
      showSolution(question);
    });

    quizRoot
  .querySelector('[data-answer-correct]')
  ?.addEventListener('click', () => {
    showCorrectResult();
  });

  quizRoot
  .querySelector('[data-answer-wrong]')
  ?.addEventListener('click', () => {
    showOpponentHandoff(category, question);
  });

  quizRoot
  .querySelector('[data-new-question]')
  ?.addEventListener('click', () => {
    stopTimer();

    const newQuestion = getDifferentQuestion(
      category,
      question
    );

    renderQuestion(category, newQuestion);
  });
}

function showSolution(question) {
  stopTimer();
  const card = quizRoot.querySelector('[data-question-card]');
  const button = quizRoot.querySelector('[data-show-solution]');
  const actions = quizRoot.querySelector('[data-answer-actions]');
  const hint = quizRoot.querySelector('[data-solution-hint]');

  if (!card || !button || !actions) return;

  card.classList.add('is-flipped');

  button.style.display = 'none';
  actions.classList.add('is-visible');
   if (hint) {
    hint.style.display = 'none';
  }
}

function showCorrectResult() {
  quizRoot.innerHTML = `
    <div class="play-quiz__result">

      <div class="play-quiz__confetti" data-confetti></div>

      <div class="play-quiz__result-icon">
        ✓
      </div>

      <p class="play-quiz__result-eyebrow">
        Richtig
      </p>

      <h2 class="play-quiz__result-title">
        Punkte gesichert!
      </h2>

      <p class="play-quiz__result-text">
        Stark gespielt – die Punkte gehören euch.
      </p>

      <button
        type="button"
        class="play-quiz__result-button"
        data-back-to-categories
      >
        Zurück zu den Kategorien
      </button>

    </div>
  `;

  launchConfetti();

  quizRoot
    .querySelector('[data-back-to-categories]')
    ?.addEventListener('click', () => {
      window.location.reload();
    });
}

function launchConfetti() {
  const container = quizRoot.querySelector('[data-confetti]');

  if (!container) return;

  const colors = [
    '#ff6500',
    '#655cc7',
    '#43a85a',
    '#f5c542',
    '#ef6a8a'
  ];

  const amount = 70;

  for (let i = 0; i < amount; i++) {
    const piece = document.createElement('span');

    piece.className = 'play-quiz__confetti-piece';

    const startX = 45 + Math.random() * 10;
    const moveX = -180 + Math.random() * 360;
    const moveY = -(420 + Math.random() * 420);
const fallY = 80 + Math.random() * 80;

    const delay = Math.random() * 0.025;
    const duration = 2.8 + Math.random() * 2.0;

    const rotationStart = Math.random() * 180;
    const rotationEnd = rotationStart + 360 + Math.random() * 540;

    const size = 6 + Math.random() * 7;
    const color = colors[Math.floor(Math.random() * colors.length)];

    piece.style.left = `${startX}%`;
    piece.style.width = `${size}px`;
    piece.style.height = `${size * 1.7}px`;
    piece.style.backgroundColor = color;

    piece.style.animationDelay = `${delay}s`;
    piece.style.animationDuration = `${duration}s`;

    piece.style.setProperty('--move-x', `${moveX}px`);
    piece.style.setProperty('--move-y', `${moveY}px`);
    piece.style.setProperty('--fall-y', `${fallY}px`);
    piece.style.setProperty('--rotation-start', `${rotationStart}deg`);
    piece.style.setProperty('--rotation-end', `${rotationEnd}deg`);

    container.appendChild(piece);
  }

  setTimeout(() => {
    container.innerHTML = '';
  }, 5000);
}


  function startTimer(seconds) {
  const timerElement = quizRoot.querySelector('[data-quiz-timer]');

  if (!timerElement) return;

  // Falls noch ein alter Timer läuft
  stopTimer();

  let remaining = seconds;

  updateTimer(timerElement, remaining);

  activeTimerInterval = setInterval(() => {
    remaining -= 1;

    updateTimer(timerElement, remaining);

    if (remaining <= 5 && remaining > 0) {
      timerElement.classList.add('is-running-out');
    }

    if (remaining <= 0) {
      clearInterval(activeTimerInterval);
      activeTimerInterval = null;

      timerElement.classList.remove('is-running-out');
      timerElement.classList.add('is-time-up');
      timerElement.textContent = 'ZEIT!';

      const questionCard =
        quizRoot.querySelector('[data-question-card]');

      if (questionCard) {
        questionCard.classList.add('is-time-up');

        setTimeout(() => {
          questionCard.classList.remove('is-time-up');
        }, 600);
      }
    }
  }, 1000);
}

function stopTimer() {
  if (activeTimerInterval) {
    clearInterval(activeTimerInterval);
    activeTimerInterval = null;
  }

  const timerElement = quizRoot.querySelector('[data-quiz-timer]');
  const questionCard = quizRoot.querySelector('[data-question-card]');

  if (timerElement) {
    timerElement.classList.remove(
      'is-running-out',
      'is-time-up'
    );
  }

  if (questionCard) {
    questionCard.classList.remove('is-time-up');
  }
}

  function updateTimer(element, seconds) {
    const safeSeconds = Math.max(0, seconds);
    const formatted = String(safeSeconds).padStart(2, '0');

    element.textContent = `00:${formatted}`;
  }

  function formatCategory(category) {
    const labels = {
      hunde: 'Hunde',
      allgemeinwissen: 'Allgemeinwissen',
      geographie: 'Geographie',
      natur: 'Natur & Tiere',
      film: 'Film & Serien',
      sport: 'Sport'
    };

    return labels[category] || category;
  }

function getCategoryIcon(category) {
  const icons = {
    hunde: '🐶',
    allgemeinwissen: '🧠',
    geographie: '🌍',
    natur: '🌿',
    film: '🎬',
    sport: '⚽'
  };

  return icons[category] || '❓';
}

function getCategoryClass(category) {
  const classes = {
    hunde: 'category-hunde',
    allgemeinwissen: 'category-allgemeinwissen',
    geographie: 'category-geographie',
    natur: 'category-natur',
    film: 'category-film',
    sport: 'category-sport'
  };

  return classes[category] || '';
}

function showOpponentHandoff(category, question) {
  quizRoot.innerHTML = `
    <div class="play-quiz__handoff">

    <div class="play-quiz__result-icon play-quiz__result-icon--wrong">
  ✕
</div>

      <p class="play-quiz__handoff-eyebrow">
        Falsch
      </p>

      <h2 class="play-quiz__handoff-title">
        Chance für den Gegner!
      </h2>

      <p class="play-quiz__handoff-text">
        Gib das Handy jetzt weiter.
        Gleich erscheint dieselbe Frage erneut und der Gegner hat 15 Sekunden Zeit.
      </p>

      <div class="play-quiz__handoff-countdown">

        <svg
          class="play-quiz__handoff-ring"
          viewBox="0 0 120 120"
          aria-hidden="true"
        >
          <circle
            class="play-quiz__handoff-ring-bg"
            cx="60"
            cy="60"
            r="54"
          ></circle>

          <circle
            class="play-quiz__handoff-ring-progress"
            cx="60"
            cy="60"
            r="54"
          ></circle>
        </svg>

        <span
          class="play-quiz__handoff-number"
          data-handoff-countdown
        >
          10
        </span>

      </div>

      <button
        type="button"
        class="play-quiz__undo-button"
        data-undo-wrong
      >
        Falsch gewertet · Rückgängig
      </button>

    </div>
  `;

  let count = 10;

  const countdownElement =
    quizRoot.querySelector('[data-handoff-countdown]');

  const interval = setInterval(() => {
    count -= 1;

    if (count > 0) {
      countdownElement.textContent = count;
    } else {
      clearInterval(interval);
      renderOpponentQuestion(category, question);
    }
  }, 1000);

  quizRoot
    .querySelector('[data-undo-wrong]')
    ?.addEventListener('click', () => {
      clearInterval(interval);
      renderQuestion(category, question);
    });
}

function renderOpponentQuestion(category, question) {
  quizRoot.innerHTML = `
    <div class="play-quiz__game">

      <div class="play-quiz__game-topbar">

        <button
          type="button"
          class="play-quiz__game-back"
          data-quiz-back
        >
          ← Zurück
        </button>

        <div class="play-quiz__game-logo-wrap">
          <img
            class="play-quiz__game-logo"
            src="${window.playQuizLogo || ''}"
            alt="Look at my dog"
          >
        </div>

      </div>


      <div class="play-quiz__opponent-label">
  Chance für den Gegner
</div>

<div class="play-quiz__game-meta">

  <div class="play-quiz__category-meta">

   <div class="play-quiz__category-meta-icon ${getCategoryClass(category)}">
  ${getCategoryIcon(category)}
</div>

    <span class="play-quiz__game-category">
      ${formatCategory(category)}
    </span>

  </div>


        <div
          class="play-quiz__timer"
          data-quiz-timer
        >
          00:15
        </div>

      </div>


      <div
        class="play-quiz__question-card"
        data-question-card
      >

        <div class="play-quiz__question-card-inner">

          <div
            class="
              play-quiz__question-face
              play-quiz__question-face--front
            "
          >

            <p class="play-quiz__question-label">
              Frage
            </p>

            <h2 class="play-quiz__question">
              ${question.question}
            </h2>

          </div>


          <div
            class="
              play-quiz__question-face
              play-quiz__question-face--back
            "
          >

            <p class="play-quiz__question-label">
              Lösung
            </p>

            <h2 class="play-quiz__answer">
              ${question.answer}
            </h2>

          </div>

        </div>

      </div>


      <button
        type="button"
        class="play-quiz__solution-button"
        data-show-opponent-solution
      >
        Lösung anzeigen
      </button>
<div class="play-quiz__answer-actions" data-opponent-answer-actions>

  <button
    type="button"
    class="play-quiz__answer-button play-quiz__answer-button--correct"
    data-opponent-correct
  >
    ✓ Richtig
  </button>

  <button
    type="button"
    class="play-quiz__answer-button play-quiz__answer-button--wrong"
    data-opponent-wrong
  >
    ✕ Falsch
  </button>

</div>

      

    </div>
  `;

  startTimer(15);

  quizRoot
    .querySelector('[data-quiz-back]')
    ?.addEventListener('click', () => {
      window.location.reload();
    });

  quizRoot
    .querySelector('[data-show-opponent-solution]')
    ?.addEventListener('click', () => {
      showOpponentSolution(question);
    });
    quizRoot
  .querySelector('[data-opponent-correct]')
  ?.addEventListener('click', () => {
    showCorrectResult();
  });

quizRoot
  .querySelector('[data-opponent-wrong]')
  ?.addEventListener('click', () => {
    showNoPointsResult();
  });
}
function showOpponentSolution(question) {
  stopTimer();
  const card = quizRoot.querySelector('[data-question-card]');
  const button = quizRoot.querySelector('[data-show-opponent-solution]');
  const actions = quizRoot.querySelector('[data-opponent-answer-actions]');

  if (!card || !button || !actions) return;

  card.classList.add('is-flipped');

  button.style.display = 'none';
  actions.classList.add('is-visible');
}
function showNoPointsResult() {
  quizRoot.innerHTML = `
    <div class="play-quiz__result play-quiz__result--wrong">

      <div class="play-quiz__result-icon play-quiz__result-icon--wrong">
        ✕
      </div>

      <p class="play-quiz__result-eyebrow play-quiz__result-eyebrow--wrong">
        Leider falsch
      </p>

      <h2 class="play-quiz__result-title">
        Diesmal keine Punkte
      </h2>

      <p class="play-quiz__result-text">
        Auch die zweite Chance war leider daneben.
        Für diese Frage bekommt niemand die Punkte.
      </p>

      <button
        type="button"
        class="play-quiz__result-button"
        data-back-to-categories
      >
        Zurück zu den Kategorien
      </button>

    </div>
  `;

  quizRoot
    .querySelector('[data-back-to-categories]')
    ?.addEventListener('click', () => {
      window.location.reload();
    });
}
function getDifferentQuestion(category, currentQuestion) {
  const questions = window.playQuizQuestions[category];

  if (!questions || questions.length <= 1) {
    return currentQuestion;
  }

  const availableQuestions = questions.filter(
    (question) => question.question !== currentQuestion.question
  );

  const randomIndex = Math.floor(
    Math.random() * availableQuestions.length
  );

  return availableQuestions[randomIndex];
}
});